import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import tinycolor from "tinycolor2";
import { useTheme } from "../../CommonComponents/ThemeProvider";

export default function BranchSelector({ value, onChange }) {
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { currentTheme } = useTheme();

    const selectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: 40,
            borderColor: state.isFocused ? currentTheme.color : "#e5e7eb",
            boxShadow: state.isFocused ? `0 0 0 1px ${currentTheme.color}` : "none",
            borderRadius: 8,
            "&:hover": { borderColor: currentTheme.color },
            fontSize: 14,
        }),
        menu: (base) => ({
            ...base,
            borderRadius: 8,
            border: "1px solid #e5e7eb",
            overflow: "hidden",
            zIndex: 30,
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
                ? currentTheme.color
                : state.isFocused
                    ? tinycolor(currentTheme.color).setAlpha(0.08).toRgbString()
                    : "white",
            color: state.isSelected ? "#fff" : "#111827",
            fontSize: 14,
        }),
        singleValue: (base) => ({
            ...base,
            color: "#111827",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#9ca3af",
        }),
        indicatorSeparator: () => ({ display: "none" }),
        dropdownIndicator: (base, state) => ({
            ...base,
            color: state.isFocused ? currentTheme.color : "#6b7280",
            "&:hover": {
                color: currentTheme.color,
            },
        }),
    };

    const branchOptions = [
        { value: "", label: "All Branches" },
        ...branches.map((branch) => ({
            value: String(branch.id),
            label: branch.name,
        })),
    ];

    useEffect(() => {
        async function fetchBranches() {
            setLoading(true);
            try {
                // Use correct endpoint and attach JWT token
                const token = localStorage.getItem("token") || sessionStorage.getItem("token");
                const backendUrl = process.env.REACT_APP_API_URL;
                const res = await axios.get(`${backendUrl}/api/admin/branches`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setBranches(res.data.data || res.data || []);
                setError(null);
            } catch (err) {
                setError("Failed to load branches");
                setBranches([]);
            }
            setLoading(false);
        }
        fetchBranches();
    }, []);

    return (
        <div className="flex items-center gap-2">
            <label htmlFor="branch-select" className="text-sm font-medium text-gray-700">Branch:</label>
            <div className="min-w-[220px] flex-1">
                <Select
                id="branch-select"
                    inputId="branch-select"
                    options={branchOptions}
                    value={branchOptions.find((option) => option.value === String(value || "")) || branchOptions[0]}
                    onChange={(option) => onChange(option?.value || "")}
                    isSearchable={false}
                    isDisabled={loading}
                    classNamePrefix="react-select"
                    styles={selectStyles}
                />
            </div>
            {loading && <span className="text-xs text-gray-400">Loading...</span>}
            {error && <span className="text-xs text-red-500">{error}</span>}
        </div>
    );
}
